// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".atom-circle-progress{border-radius:50%;cursor:pointer;display:block;height:2.5rem;overflow:hidden;position:relative;width:2.5rem}.atom-circle-progress .icon{left:50%;position:absolute;top:50%;transform:translate(-50%,-50%)}.atom-circle-progress .circle canvas{height:100%!important;width:100%!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
